import React, { Suspense } from 'react';

const NewResultsAnimationComponent = React.lazy(() => import('./NewResultsAnimation'));

export const NewResultsAnimation = () => (
  <Suspense fallback={null}>
    <NewResultsAnimationComponent />
  </Suspense>
);
